"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MonthlyChart = require("./MonthlyChart");

var _CumulativeChart = require("./CumulativeChart");

var _FifteenMinuteChart = require("./FifteenMinuteChart");

var _DailyChart = require("./DailyChart");

var _views = require("../constants/views");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable react/require-default-props */
var Legend = function Legend(_ref) {
  var chartType = _ref.chartType,
      hasBattery = _ref.hasBattery,
      hasCT = _ref.hasCT,
      timeZone = _ref.timeZone,
      viewStartISO = _ref.viewStartISO,
      viewEndISO = _ref.viewEndISO,
      view = _ref.view;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (view === _views.DAILY || view === _views.WEEKLY) && /*#__PURE__*/_react["default"].createElement(_FifteenMinuteChart.FifteenMinuteLegend, {
    hasBattery: hasBattery,
    hasCT: hasCT
  }), view === _views.MONTHLY && chartType === _views.STANDARD && /*#__PURE__*/_react["default"].createElement(_DailyChart.DailyLegend, {
    hasBattery: hasBattery,
    hasCT: hasCT,
    viewStartISO: viewStartISO,
    viewEndISO: viewEndISO,
    timeZone: timeZone
  }), view === _views.MONTHLY && chartType === _views.CUMULATIVE && /*#__PURE__*/_react["default"].createElement(_CumulativeChart.CumulativeLegend, {
    hasBattery: hasBattery
  }), view === _views.ALL && chartType === _views.STANDARD && /*#__PURE__*/_react["default"].createElement(_MonthlyChart.MonthlyLegend, {
    hasBattery: hasBattery,
    hasCT: hasCT
  }), view === _views.ALL && chartType === _views.CUMULATIVE && /*#__PURE__*/_react["default"].createElement(_CumulativeChart.CumulativeLegend, {
    hasBattery: hasBattery
  }));
};

Legend.propTypes = {
  chartType: _propTypes["default"].oneOf([_views.STANDARD, _views.CUMULATIVE]).isRequired,
  viewEndISO: _propTypes["default"].string.isRequired,
  hasBattery: _propTypes["default"].bool.isRequired,
  hasCT: _propTypes["default"].bool.isRequired,
  timeZone: _propTypes["default"].string,
  viewStartISO: _propTypes["default"].string.isRequired,
  view: _propTypes["default"].oneOf([_views.DAILY, _views.WEEKLY, _views.MONTHLY, _views.ALL]).isRequired
};
Legend.defaultProps = {
  timeZone: 'local'
};
var _default = Legend;
exports["default"] = _default;